// Module-level singleton cache for Event History, so the page survives route
// navigation (component state/refs are destroyed on unmount). One shared
// snapshot per SPA session; on re-entry the page renders it instantly, then
// revalidates only the delta. The audit table is append-only, so the delta is
// just the new rows at the newest (top) end.

let snapshot = null; // { key, state, savedAt }

// View key (filters + date window + sort). A different key = a different
// dataset, so the snapshot does not apply.
export const buildAuditKey = (serverFilters, dateRange, sortingField, sortingDescending) =>
  JSON.stringify({
    f: serverFilters || {},
    d:
      dateRange && dateRange.type === 'absolute'
        ? { s: dateRange.startDate || null, e: dateRange.endDate || null }
        : dateRange || null,
    sf: sortingField || 'timestamp',
    sd: !!sortingDescending,
  });

export const getAuditSnapshot = (key) =>
  snapshot && snapshot.key === key ? snapshot : null;

// state: render-state to restore instantly.
export const saveAuditSnapshot = (key, state) => {
  snapshot = { key, state, savedAt: Date.now() };
};

export const clearAuditSnapshot = () => {
  snapshot = null;
};
